/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UppyUploadDirective } from './uppy-upload-directive';
import { UppyUploadService } from './uppy-upload.service';

/**
 * Feature Module for our Uppy.
 */
@NgModule({
  declarations: [
    UppyUploadDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [
    UppyUploadDirective,
  ],
  providers: [
    UppyUploadService,
  ],
})
export class UppyModule {}
